import { ia } from 'lib/helpers/utility';

export const cardOptions = (cards) => [
  {
    label: 'Saved Card',
    value: 'saved-cards',
    disabled: !ia(cards),
    tooltip: !ia(cards) && "You don't have any saved cards"
  },
  {
    label: 'New Card',
    value: 'credit-card'
  }
];
